<div mat-dialog-title fxLayout="row" fxLayoutAlign="space-between center">
  <h1 class="mat-h1">Edit Invoice Item</h1>
  <button
    mat-icon-button
    matTooltip="Return to Invoice Dashboard"
    matTooltipShowDelay="1000"
    (click)="onCancel()"
    color="primary"
  >
    <mat-icon color="primary">cancel</mat-icon>
  </button>
</div>
<form *ngIf="onReady" novalidate class="sk-form" [formGroup]="invoiceForm" (ngSubmit)="onSubmit()" fxLayout="column">

  <div *ngIf="!editMode">
    <mat-form-field ngClass.gt-sm="input-50-field" ngClass.lt-md="input-100-field" appearance="outline"
                    floatLabel="never">
      <mat-label>Project</mat-label>
      <input matInput [matAutocomplete]="projectAuto" formControlName="project"/>

      <mat-autocomplete #projectAuto="matAutocomplete" [displayWith]="displayProject">
        <ng-container *ngIf="(filteredProjects | async)?.length; else noOptions">
          <mat-option *ngFor="let project of (filteredProjects | async)" [value]="project">
            {{ project?.name }}
          </mat-option>
        </ng-container>
        <ng-template #noOptions>
          <mat-option [value]="defaultValue" class="no-data">
            <span i18n="@@sk-noSelectionsFound" *ngIf="invoiceForm.get('project').value">No Selections Found</span>
          </mat-option>
        </ng-template>
      </mat-autocomplete>

      <mat-error *ngIf="invoiceForm.get('project').hasError('required')">Please choose a
        project
      </mat-error>
    </mat-form-field>
  </div>
  <div *ngIf="!editMode" fxLayout="row" fxLayoutAlign="flex-start center" fxLayoutGap="10px">
    <mat-form-field ngClass.gt-sm="input-75-field" ngClass.lt-md="input-100-field" appearance="outline"
                    floatLabel="never">
      <mat-label>Invoice Item Date</mat-label>
      <input cdkFocusInitial matInput [matDatepicker]="invoiceDate"
             formControlName="invoiceDate"/>
      <mat-datepicker-toggle matSuffix [for]="invoiceDate"></mat-datepicker-toggle>
      <mat-datepicker #invoiceDate></mat-datepicker>
      <mat-error i18n="@@sk-requiredField" *ngIf="invoiceForm.get('invoiceDate').hasError('required')">This field is
        required
      </mat-error>
    </mat-form-field>
  </div>
  <div *ngIf="!editMode" class="input-60-field" fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="flex-start center">
    <mat-label>Item Type</mat-label>
    <mat-form-field>
      <mat-select formControlName="invoiceType">
        <mat-option value="Project">Project</mat-option>
        <mat-option value="Material">Material</mat-option>
      </mat-select>
    </mat-form-field>
  </div>


  <div fxLayout="row" ngClass.gt-sm="input-50-field" ngClass.lt-md="input-100-field" fxLayoutAlign="start center">
    <mat-form-field appearance="outline" floatLabel="never">
      <mat-label class="text-label" *ngIf="hourly">Hours to Bill</mat-label>
      <mat-label class="text-label" *ngIf="!hourly">Quantity</mat-label>
      <input matInput class="invoice-input" type="number" formControlName="quantity">
    </mat-form-field>
  </div>

  <div fxLayout="row" ngClass.gt-sm="input-50-field" ngClass.lt-md="input-100-field" fxLayoutAlign="start center">
    <mat-form-field appearance="outline" floatLabel="never">
      <mat-label class="text-label" *ngIf="hourly">Hourly Rate</mat-label>
      <mat-label class="text-label" *ngIf="!hourly">Amount</mat-label>
      <input matInput class="invoice-input" type="number" formControlName="unitPrice">
    </mat-form-field>
  </div>


  <div fxLayout="row" class="total-line" fxLayoutGap="10px" fxLayoutAlign="start center">
    <mat-label class="text-label">Subtotal</mat-label>
    <div>{{invoiceSubtotal | customCurrency }} </div>
  </div>


  <div fxLayout="row" fxLayoutAlign="start center">
    <mat-form-field appearance="outline" floatLabel="never">
      <mat-label class="text-label">Sales Tax</mat-label>
      <mat-select formControlName="salesTaxRate" [compareWith]="compareTax" matInput>
        <mat-option *ngFor="let taxRate of taxRates$ | async" [value]=taxRate>
          {{ taxRate.description }} / {{ taxRate.rate }}%
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>


  <div fxLayout="row" class="total-line" fxLayoutGap="10px" fxLayoutAlign="start center">
    <mat-label class="text-label">Sales Tax</mat-label>
    <div>{{salesTaxAmount | customCurrency }} </div>
  </div>


  <div *ngIf="invoiceType !== 'Material'" fxLayout="row" fxLayoutAlign="start center">
    <mat-form-field appearance="outline" floatLabel="never">
      <mat-label class="text-label">Service</mat-label>
      <mat-select formControlName="service" [compareWith]="compareService" matInput>
        <mat-option *ngFor="let acctService of acctServices" [value]=acctService>
          {{ acctService.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div *ngIf="invoiceType === 'Material'" fxLayout="row" fxLayoutAlign="start center">
    <mat-form-field appearance="outline" floatLabel="never">
      <mat-label class="text-label">Product</mat-label>
      <mat-select formControlName="product" [compareWith]="compareProduct" matInput>
        <mat-option *ngFor="let product of products" [value]=product>
          {{ product.productName }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div fxLayout="row" fxLayoutAlign="start center">
    <mat-form-field appearance="outline" floatLabel="never">
      <mat-label class="text-label">Description</mat-label>
      <input matInput class="invoice-input" type="text" formControlName="invoiceDescription">
      <mat-error i18n="@@sk-requiredField" *ngIf="invoiceForm.get('invoiceDescription').hasError('required')">This field
        is required
      </mat-error>
      <mat-error i18n="@@sk-maxLength60" *ngIf="invoiceForm.get('invoiceDescription').hasError('maxlength')">This field
        can contain max 60 characters
      </mat-error>
    </mat-form-field>
  </div>

  <div fxLayout="row" class="total-line" fxLayoutGap="10px" fxLayoutAlign="start center">
    <div class="text-label">Invoice Item Total</div>
    <div>{{invoiceTotal | customCurrency }} </div>
  </div>

  <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">
    <button
      mat-button color="accent"
      type="button"
      (click)="onCancel()">Cancel
    </button>
    <button mat-raised-button class="save-button" color="primary" type="submit">
      Save
    </button>
  </div>
</form>
